import { render, staticRenderFns } from "./UserRoles.vue?vue&type=template&id=c4132fba&"
import script from "./UserRoles.vue?vue&type=script&lang=js&"
export * from "./UserRoles.vue?vue&type=script&lang=js&"
import style0 from "./UserRoles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports